import { FiSearch, FiFilter } from "react-icons/fi";

type SortOption =
  | "name_asc"
  | "name_desc"
  | "validity_desc"
  | "validity_asc"
  | "workouts_count_desc"
  | "workouts_count_asc"
  | "appointments_count_desc"
  | "appointments_count_asc"
  | "foods_count_desc"
  | "foods_count_asc"
  | "avaliations_count_desc"
  | "avaliations_count_asc"
  | "birth_date_asc"
  | "birth_date_desc";

interface StudentsFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  sortOption: SortOption;
  onSortChange: (value: SortOption) => void;
  filteredCount: number;
  genderFilter: string;
  onGenderChange: (value: string) => void;
}

function StudentsFilters({
  search,
  onSearchChange,
  sortOption,
  onSortChange,
  filteredCount,
  genderFilter,
  onGenderChange,
}: StudentsFiltersProps) {
  return (
    <div className="border-b border-stroke px-4 py-4 dark:border-strokedark sm:px-6 sm:py-5 md:px-7 md:py-6">
      <div className="flex flex-col gap-3 sm:gap-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <h3 className="text-base font-bold text-gray-900 dark:text-white sm:text-lg md:text-xl">
              Lista de Alunos
            </h3>
            <span className="rounded-full bg-purple-100 px-2 py-0.5 text-xs font-semibold text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 sm:px-3 sm:py-1 sm:text-sm">
              {filteredCount}
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
          {/* Search */}
          <div className="relative flex-1">
            <FiSearch
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 sm:left-4"
              size={18}
            />
            <input
              type="text"
              placeholder="Buscar por nome..."
              value={search}
              onChange={({ target }) => onSearchChange(target.value)}
              className="w-full rounded-lg border border-stroke bg-gray-50 py-2.5 pl-10 pr-3 text-sm font-medium outline-none transition focus:border-purple-500 focus:bg-white focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500 sm:rounded-xl sm:py-3 sm:pl-12 sm:pr-4"
            />
          </div>

          {/* Sort */}
          <div className="relative w-full sm:w-64">
            <FiFilter
              className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-gray-400 sm:left-4"
              size={16}
            />
            <select
              value={sortOption}
              onChange={(e) => onSortChange(e.target.value as SortOption)}
              className="relative w-full appearance-none rounded-lg border border-stroke bg-gray-50 py-2.5 pl-10 pr-8 text-sm font-medium text-gray-700 outline-none transition focus:border-purple-500 focus:bg-white focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500 sm:rounded-xl sm:py-3 sm:pl-12 sm:pr-10"
            >
              <option value="name_asc">Nome (A-Z)</option>
              <option value="name_desc">Nome (Z-A)</option>
              <option value="validity_desc">Validade (mais recente)</option>
              <option value="validity_asc">Validade (mais antiga)</option>
              <option value="workouts_count_desc">Qtd. Treinos (maior)</option>
              <option value="workouts_count_asc">Qtd. Treinos (menor)</option>
              <option value="appointments_count_desc">
                Qtd. Agendamentos (maior)
              </option>
              <option value="appointments_count_asc">
                Qtd. Agendamentos (menor)
              </option>
              <option value="foods_count_desc">Qtd. Alimentos (maior)</option>
              <option value="foods_count_asc">Qtd. Alimentos (menor)</option>
              <option value="avaliations_count_desc">
                Qtd. Avaliações (maior)
              </option>
              <option value="avaliations_count_asc">
                Qtd. Avaliações (menor)
              </option>
              <option value="birth_date_asc">Aniversário (Jan-Dez)</option>
              <option value="birth_date_desc">Aniversário (Dez-Jan)</option>
            </select>
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 sm:right-4">
              <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24">
                <path d="M7 10l5 5 5-5H7z" />
              </svg>
            </span>
          </div>

          {/* Gender Filter */}
          <div className="relative w-full sm:w-48">
            <FiFilter
              className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-gray-400 sm:left-4"
              size={16}
            />
            <select
              value={genderFilter}
              onChange={(e) => onGenderChange(e.target.value)}
              className="relative w-full appearance-none rounded-lg border border-stroke bg-gray-50 py-2.5 pl-10 pr-8 text-sm font-medium text-gray-700 outline-none transition focus:border-purple-500 focus:bg-white focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500 sm:rounded-xl sm:py-3 sm:pl-12 sm:pr-10"
            >
              <option value="">Todos os Gêneros</option>
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
              <option value="O">Outro</option>
              <option value="N">Prefiro não informar</option>
            </select>
            <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 sm:right-4">
              <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24">
                <path d="M7 10l5 5 5-5H7z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentsFilters;
